export default function(instance) {
  return {
    //Categories
    getCategories(data) {
      Object.keys(data).forEach(
        k => !data[k] && data[k] !== undefined && delete data[k]
      );

      return instance.get("/api/booking/categories/admin/", { params: data });
    },
    createCategory(data) {
      return instance.post("/api/booking/categories/admin/", {
        name: data.name
      });
    },
    getCategory(idCategory) {
      return instance.get(`/api/booking/categories/admin/${idCategory}/`);
    },
    updateCategory(idCategory, data) {
      return instance.put(`/api/booking/categories/admin/${idCategory}/`, {
        name: data.name
      });
    },
    deleteCategory(idCategory) {
      return instance.delete(`/api/booking/categories/admin/${idCategory}/`);
    },
    //END Categories

    //Мероприятия
    getEvents(data) {
      Object.keys(data).forEach(
        k => !data[k] && data[k] !== undefined && delete data[k]
      );

      return instance.get("/api/booking/events/admin/", { params: data });
    },
    createEvent(data) {
      return instance.post("/api/booking/events/admin/", {
        name: data.name,
        description: data.description,
        date: data.date, //"2020-12-02"
        category: data.idCategory, //id category
        price: data.price,
        date_start: data.dateStart, //"2020-12-02T10:00:00"
        date_end: data.dateEnd, //"2020-12-02T10:00:00"
        max_participants: data.max,
        min_participants: data.min,
        background_color: data.background_color,
        time_color: data.time_color,
        name_color: data.name_color,
        arrow_color: data.arrow_color
      });
    },
    getEvent(idEvent) {
      return instance.get(`/api/booking/events/admin/${idEvent}/`);
    },
    updateEvent(idEvent, data) {
      return instance.put(`/api/booking/events/admin/${idEvent}/`, {
        name: data.name,
        description: data.description,
        date: data.date, //"2020-12-02"
        category: data.idCategory, //id category
        price: data.price,
        date_start: data.dateStart, //"2020-12-02T10:00:00"
        date_end: data.dateEnd, //"2020-12-02T10:00:00"
        max_participants: data.max,
        min_participants: data.min,
        background_color: data.background_color,
        time_color: data.time_color,
        name_color: data.name_color,
        arrow_color: data.arrow_color
      });
    },
    deleteEvent(idEvent) {
      return instance.delete(`/api/booking/events/admin/${idEvent}/`);
    },
    //END Мероприятия

    //Бронивароние
    getOrders() {
      return instance.get("/api/booking/events/orders/admin/");
    },
    createOrder(data) {
      return instance.post("/api/booking/events/orders/admin/", {
        event: data.eventID,
        price: data.price,
        ticket_quantity: data.quantity
      });
    },
    getOrder(idOrder) {
      return instance.get(`/api/booking/events/orders/admin/${idOrder}/`);
    },
    updateOrder(idOrder, data) {
      return instance.put(`/api/booking/events/orders/admin/${idOrder}/`, {
        user: data.userID,
        event: data.eventID,
        price: data.price,
        ticket_quantity: data.quantity,
        is_cancelled: data.is_cancelled,
        is_paid: data.is_paid
      });
    },
    deleteOrder(idOrder) {
      return instance.delete(`/api/booking/events/orders/admin/${idOrder}/`);
    },

    cancelOrder(idOrder) {
      return instance.put(`/api/booking/events/orders/admin/${idOrder}/`, {
        is_cancelled: true
      });
    }
    //END Бронивароние
  };
}
